import { useEffect, useState } from "react";
import { API } from "@/lib/api";

let cache = null;
const listeners = new Set();

export const refreshBranding = () => fetch(`${API}/branding`).then((r) => r.json()).then((b) => {
  cache = b;
  listeners.forEach((fn) => fn(b));
}).catch(() => {});

export const useBranding = () => {
  const [b, setB] = useState(cache);
  useEffect(() => {
    listeners.add(setB);
    if (!cache) refreshBranding();
    return () => listeners.delete(setB);
  }, []);
  return b;
};

export const BrandLogo = ({ className = "h-10", testid = "company-logo" }) => {
  const b = useBranding();
  if (b?.has_logo) {
    return <img src={`${API}/branding/logo?v=${encodeURIComponent(b.updated_at || "")}`} alt="Nini's Collective" className={`${className} w-auto object-contain`} data-testid={testid} />;
  }
  return <span className="font-display text-sm font-bold uppercase tracking-[0.18em] text-slate-500" data-testid={`${testid}-text`}>Nini's Collective</span>;
};
